import { motion } from 'framer-motion'
import { X } from 'lucide-react'
import { ExpandedImageProps } from '../types'

export const ExpandedImage = ({ src, alt, onClose }: ExpandedImageProps) => {
  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation()
    onClose()
  }

  const imageSrc = src && src.trim() !== '' 
    ? src 
    : '/images/placeholders/image-place-holder.png'

  return (
    <motion.div
      className='fixed inset-0 z-[10000] flex items-center justify-center bg-black/90'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.15 }}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className='absolute right-4 top-4 z-[10001] flex h-10 w-10 items-center justify-center rounded-full bg-white/20 text-white transition-colors hover:bg-white/40'
        onClick={handleClose}
        aria-label='Close'
      >
        <X size={24} />
      </button>

      <motion.img
        src={imageSrc}
        alt={alt || 'Imagem expandida'}
        className='max-h-[90vh] max-w-[90vw] object-contain'
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ type: 'spring', stiffness: 300, damping: 25 }}
        onClick={(e) => e.stopPropagation()}
      />
    </motion.div>
  )
} 